import { Button, Card } from 'antd'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import './manual.less'
import { AudioMaterials } from './components/audio-materials/audio-materials'
import { PdfMaterialsSection } from './components/book-materials/pdf-materials-section'
import { VideoMaterials } from './components/video-materials/video-materials'

const Manual: React.FC = () => {
  const [t] = useTranslation()
  const [view, setView] = useState<
    'video' | 'book' | 'audio' | 'pupilGrowingMap'
  >('video')

  const renderTabs = useMemo(() => {
    return (
      <div style={{ display: 'flex', gap: '10px' }}>
        <Button
          onClick={() => setView('video')}
          type={view === 'video' ? 'primary' : 'default'}>
          {t('manual.video')}
        </Button>
        <Button
          onClick={() => setView('audio')}
          type={view === 'audio' ? 'primary' : 'default'}>
          {t('manual.audio')}
        </Button>
        <Button
          onClick={() => setView('book')}
          type={view === 'book' ? 'primary' : 'default'}>
          {t('manual.book')}
        </Button>
        <Button
          onClick={() => setView('pupilGrowingMap')}
          type={view === 'pupilGrowingMap' ? 'primary' : 'default'}>
          {t('manual.pupilGrowingMap')}
        </Button>
      </div>
    )
  }, [view, t])

  return (
    <div>
      <Card className="tabs-card">{renderTabs}</Card>

      {view === 'video' && <VideoMaterials />}
      {view === 'audio' && <AudioMaterials />}
      {view === 'book' && <PdfMaterialsSection />}
      {view === 'pupilGrowingMap' && (
        <PdfMaterialsSection onlyPupilGrowingMapBook />
      )}
    </div>
  )
}

export default Manual
